<script setup>
/**
 * Stand-in for Nuxt's <NuxtLink> so the public-site block components render
 * unchanged inside the admin preview canvas. A plain anchor — navigation is
 * swallowed by LiveCanvas's capture-phase click handler, so `href` is cosmetic
 * (it just makes the markup match the real site). Registered globally in main.js.
 */
defineProps({
  to: { type: [String, Object], default: "#" },
  external: { type: Boolean, default: false },
});
function href(to) {
  if (!to) return "#";
  return typeof to === "string" ? to : (to.path || "#");
}
</script>

<template>
  <a :href="href(to)"><slot /></a>
</template>
